import { axios } from '@src/plugins/axios'

async function find(idPersonal, idEvaluacionAnual) {
  const response = await axios.get(
    `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/evaluacionAnual/${idEvaluacionAnual}`
  )

  return response.data
}

async function create(idPersonalEvaluado, evaluacionAnual) {
  const response = await axios.post(
    `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonalEvaluado}/evaluacionAnual`,
    evaluacionAnual
  )

  return response.data
}

async function update(idPersonalEvaluado, idEvaluacionAnual, evaluacionAnual) {
  const response = await axios.put(
    `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonalEvaluado}/evaluacionAnual/${idEvaluacionAnual}`,
    evaluacionAnual
  )

  return response.data
}

async function updateStatus(idPersonalEvaluado, idEvaluacionAnual, status) {
  const response = await axios.put(
    `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonalEvaluado}/evaluacionAnual/${idEvaluacionAnual}/estatus`,
    { fk_idCatEstatusEvaluacion: status }
  )

  return response.data
}

async function getRubros() {
  const { data } = await axios.get('/PoliciaCuadrantes/DesarrolloPolicial/criterioEvaluacion')

  return data.data
}

async function getReactivos(tipoEvaluacion) {
  const { data } = await axios.get(
    `/PoliciaCuadrantes/DesarrolloPolicial/evaluacion/${tipoEvaluacion}/descripcionCriterio`
  )

  return data.data
}

async function getFrecuencias() {
  return [
    { id: 1, title: 'Nunca' },
    { id: 2, title: 'Casi Nunca' },
    { id: 3, title: 'Algunas Veces' },
    { id: 4, title: 'Casi Siempre' },
    { id: 5, title: 'Siempre' },
  ]
}

const EvaluacionAnualApiRepository = {
  find,
  create,
  update,
  updateStatus,
  getRubros,
  getReactivos,
  getFrecuencias,
}

export default EvaluacionAnualApiRepository
